var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconParamsYellow16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaart-/-Master-/-Expanded",
    transform: "translate(-328.000000, -203.000000)",
    stroke: "#F0B423",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(24.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(250.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(55.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Graph_Yellow-16px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,7 C14,10.8659935 10.8659935,14 7,14 C3.13400652,14 0,10.8659935 0,7 C0,3.13400652 3.13400652,0 7,0 C10.8659935,0 14,3.13400652 14,7 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625,7.0625 L10.9375,7.0625",
    id: "Stroke-3"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParamsYellow16Px);
export default __webpack_public_path__ + "static/media/Icon_Params_Yellow-16px.22e6312b2888a01d8ad597638a05a4f1.svg";
export { ForwardRef as ReactComponent };